var DateSelectorTitle = (function (_eventHandler, _dsEventHandler) {
    var templateName = 'date-picker-title';
    var $el = $.tmpl(templateName);

    var _subscribe = function () {
        $el.find('@titlePrev').on('click', function () {
            _eventHandler.trigger('clickPrev');
        });

        $el.find('@titleNext').on('click', function () {
            _eventHandler.trigger('clickNext');
        });

        $el.find('@titleYear').on('click', function () {
            _eventHandler.trigger('clickYear');
        });

        $el.find('@titleMonth').on('click', function () {
            _eventHandler.trigger('clickMonth');
        });

        $el.find('@titleDay').on('click', function () {
            _eventHandler.trigger('clickDay');
        });

        _dsEventHandler.onDisplay(function(e, display) {
            var visibility = display === 'years' ? 'visible' : 'hidden';
            $el.find('@titlePrev').css('visibility', visibility);
            $el.find('@titleNext').css('visibility', visibility);
        });
    };

    return {
        init: function () {
            _subscribe();
        },
        appendTo: function ($container) {
            $container.append($el);
        },
        setYear: function (value) {
            $el.find('@titleYear').text(value || "Day");
        },
        setMonth: function (value) {
            $el.find('@titleMonth').text(value || "Month");
        },
        setDay: function (value) {
            $el.find('@titleDay').text(value || "Year");
        },
        onClickPrev: function (func) {
            _eventHandler.on('clickPrev', func);
        },
        onClickNext: function (func) {
            _eventHandler.on('clickNext', func);
        },
        onDisplayYears: function (func) {
            _eventHandler.on('clickYear', func);
        },
        onDisplayMonthes: function (func) {
            _eventHandler.on('clickMonth', func);
        },
        onDisplayDays: function (func) {
            _eventHandler.on('clickDay', func);
        }
    }
});